import React from "react";
import {IoMdSwap} from "react-icons/io";

export default function SwitcherIcon(props) {
    return <IoMdSwap {...props} />;
}
